import React from 'react'
import PropTypes from 'prop-types'
import ConsultorMais from '../Icons/ConsultorMais'
import Link from '../Link/Link'
import Text from '../Text/Text'
import Menu from '../Menu/Menu'
import backImg from './back.svg'
import styles from './externalLayout.module.scss'

const ExternalLayout = (props) => {
  const { back, children, hideMenu } = props

  const hasBackLink = back?.url

  const backLabel = 'Voltar'

  return (
    <div className={styles.externalLayout}>
      <div className={styles.container}>
        {hasBackLink ? (
          <Link className={styles.back} to={back.url} alt={backLabel}>
            <img src={backImg} alt={backLabel} />

            <Text size="xs" color="gray" value={backLabel} />
          </Link>
        ) : null}
        <div className={styles.content}>
          <div id="content">{children}</div>
        </div>
        {!hideMenu && (
          <div className={styles.menu}>
            <Menu />
          </div>
        )}
      </div>

      <div className={styles.rightColumn}>
        <div className={styles.rightColumnLogo}>
          <ConsultorMais />
        </div>
      </div>
    </div>
  )
}

ExternalLayout.defaultProps = {
  back: null,
  children: null,
  hideMenu: false
}

ExternalLayout.propTypes = {
  back: PropTypes.shape({
    url: PropTypes.string,
    alt: PropTypes.string
  }),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.element]),
  hideMenu: PropTypes.bool
}

export default ExternalLayout
